import React, { PureComponent } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { getFormattedDates, getConceptCount, phaseDelete, getIndexOfNextNonRevisionPhase } from '../helper';
import { DELETE_PHASE, REVISION } from '../../../Constants/constants';
import { ExpandToggleButton, EditMilestone, AddNewMilestone } from './';
import { bullets, phaseName, dateStyle, editCTC, disableEditCta, deleteIcon, chipStyle } from './phaseStyles';
import WarningPopup from './WarningPopup';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { contentManagementAction } from '../../../reducers/contentMangementData';
import { showMsg } from '../../../../course/actions/loaderAlert';
import { Chip, Tooltip } from '@material-ui/core';

interface PhaseProps {
  phaseData: any;
  handleExpandOnDrag: Function;
  handleExpandNode: Function;
  isExpanded: boolean;
  subjectTab: string;
  phaseAlignmentResponse: any;
  isConflict?: boolean;
  treeData: any;
  setTreeData: Function;
  showMsg: any;
  isVersion: boolean;
}

interface PhaseState {
  isEdit: boolean;
  delete: boolean;
} 

class Phase extends PureComponent<PhaseProps, PhaseState> {
  constructor(props: PhaseProps) {
    super(props);
    this.state = {
      isEdit: this.props.isConflict || (!this.props.phaseData.isDisable && this.props.isVersion ? true : false),
      delete: false,
    };
  }

  renderEdit = () => {
    this.setState({ isEdit: !this.state.isEdit });
  };

  handleDelete = () => {
    const {treeData, phaseData, showMsg} = this.props;
    const {totalPhases} = treeData;
    const index = getIndexOfNextNonRevisionPhase(phaseData.phaseIndex, treeData.phases);
    let haveContent = false;
    index >= 0 && treeData.phases[index].weeks.forEach((week:any) => {
        if(week.subjects.length) {
          haveContent = true;
        }
    })
    if((phaseData.phaseIndex !== totalPhases-1 && index !== -1 ) || (phaseData.phaseIndex === totalPhases-1 && (phaseData.isRevision || !haveContent)) ){
      this.setState((prevState) => ({ ...prevState, delete: true }));
    }
    else{
      showMsg("Last non-revision phase cannot be deleted until new phase is not created below last phase", "error");
    }
  };

  handleDeleteConfirmation = (confirmed: boolean) => {
    const { phaseData, treeData, setTreeData } = this.props;
    if (confirmed) {
      phaseDelete(phaseData.phaseIndex, treeData, setTreeData);
    }
    this.setState((prevState) => ({ ...prevState, delete: false }));
  };
  render = () => {
    const { phaseData, handleExpandOnDrag, handleExpandNode, isExpanded, subjectTab, treeData, isConflict } = this.props;
    const {endDate:courseEndDate, displaySettings} = treeData;
    const { phaseIndex, startDate, endDate, children,chapterContent,conceptContent, content } = phaseData;
    const hasValidChildren = children && children.length || (chapterContent &&chapterContent.length) ||(conceptContent && conceptContent.length) || (content && content.length) ;
    const needCourseExtension = new Date(endDate).getTime() > new Date(courseEndDate).getTime();
    return (
      <>
        <AddNewMilestone data={phaseData} />
        <Droppable droppableId={`phase-${phaseIndex}`}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{
                lineHeight: '1',
                backgroundColor: isConflict ? '#FFF4F4' : 'white',
                padding: isConflict ? '20px 1.8%' : 'initial',
                margin: isConflict ? '-20px -2.1%' : '',
                borderLeft: isConflict ? '10px solid #f4290d' : '',
                marginTop: isConflict ? '-15px' : '',
              }}
            >
              {snapshot.isDraggingOver && hasValidChildren && !isExpanded ? handleExpandOnDrag() : ''}
              <div>
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingBottom: 10,
                    padding: '7px 0',
                  }}
                >
                  {isConflict && needCourseExtension ? 
                  <p>
                    <span style={{color:'red'}}>*</span>
                    <span>
                    You need to extend the course duration in order to add the new phase
                    </span>
                    </p> :
                  <></>}
                  {hasValidChildren ? (
                    <ExpandToggleButton handleClick={handleExpandNode} isExpanded={isExpanded} isBulkDataAdded={phaseData && phaseData.isBulkDataAdded} />
                  ) : (
                    <></>
                  )}
                  <span style={phaseName}>{phaseData.name} </span>
                  {phaseData.isRevision ?

                  <Chip
                  label='Revision'
                  // className={[classes.chip, classes.chipStyle].join(" ")}
                  style={chipStyle}
                  component="a"
                  variant="outlined"
                  />: <></>}
                  <span style={bullets}>&bull;</span>
                  <span style={dateStyle}>{getFormattedDates(startDate, endDate)}</span>

                  {phaseData.isDisable ? (
                     <Tooltip
                     placement="right-start"
                     title="Aligned Phases/ Weeks are not editable/removable"
                     >
                    <span style={disableEditCta}>
                      <img src='/assets/svg/editOutline.svg' alt='edit-icon' />
                    </span>
                    </Tooltip>
                  ) : (
                    <span onClick={this.renderEdit} style={editCTC}>
                      <img src='/assets/svg/editOutline.svg' alt='edit-icon' />
                    </span>
                  )}
                  {
                    phaseData.isDisable ?(
                      <Tooltip
                      placement="right-start"
                      title="Aligned Phases/ Weeks are not editable/removable"
                      >
                      <span style={disableEditCta}>
                      <img src='/assets/svg/myLibrary/delete-outline.svg' alt='delete-icon' />
                      </span>
                    </Tooltip>
                    ):(
                    <span onClick={this.handleDelete} style={deleteIcon}>
                    <img src='/assets/svg/myLibrary/delete-outline.svg' alt='delete-icon' />
                  </span>
                    )
                  }
                </span>
                <span>
                  {this.state.isEdit ? (
                    <EditMilestone
                      confirmationFor={REVISION}
                      editMiles={true}
                      parent={phaseData}
                      close={this.renderEdit}
                      wasRevision={phaseData.isRevision}
                      isConflict={this.props.isConflict || false}
                    />
                  ) : (
                    <></>
                  )}
                </span>

                <div>{getConceptCount(phaseData, subjectTab, displaySettings)}</div>
              </div>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        {this.state.delete ? (
          <WarningPopup
            isDialogOpen={this.state.delete}
            handleResponse={this.handleDeleteConfirmation}
            confirmationFor={DELETE_PHASE}
          />
        ) : (
          <></>
        )}
      </>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setTreeData: contentManagementAction.setTreeData,
      showMsg: showMsg,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(Phase);
